import React from "react"

const TECHS_A = [
  "python",
  "typescript",
  "javascript",
  "react",
  "nodedotjs",
  "nextdotjs",
  "django",
  "fastapi",
  "nestjs",
  "postgresql",
  "redis",
  "mongodb",
]

const TECHS_B = [
  "docker",
  "kubernetes",
  "amazonaws",
  "googlecloud",
  "terraform",
  "githubactions",
  "nginx",
  "linux",
  "grafana",
  "prometheus",
  "openai",
  "rabbitmq",
]

interface RowProps {
  items: string[]
  reverse?: boolean
}

const Row: React.FC<RowProps> = ({ items, reverse }) => {
  const doubled = [...items, ...items]
  return (
    <div className={`marquee-row${reverse ? " reverse" : ""}`}>
      <div className="marquee-track">
        {doubled.map((slug, i) => (
          <span className="marquee-chip" key={`${slug}-${i}`}>
            <img
              className="marquee-icon"
              src={`https://cdn.jsdelivr.net/npm/simple-icons@v5/icons/${slug}.svg`}
              alt={slug}
              loading="lazy"
            />
            <span className="marquee-name">{slug}</span>
          </span>
        ))}
      </div>
    </div>
  )
}

const TechMarquee: React.FC = () => {
  return (
    <section className="tech-marquee" aria-label="Stack">
      <div className="marquee-label">
        <span className="marquee-dot" aria-hidden="true" />
        <span>stack · realtime</span>
      </div>
      <div className="marquee-rows">
        <Row items={TECHS_A} />
        <Row items={TECHS_B} reverse />
      </div>
    </section>
  )
}

export default TechMarquee
